import IsNullOrUndefined from "../utils/ObjectUtils";
import IsNullOrEmpty from "../utils/StringUtils";

export const CameraShotUtility = {
    getCameraShot: (projectId, room, currentCamera, categories) =>
    {
        let categoriesSelectionString = '';
        const sectionSeparator = '.';
        const categorySelectionSeparator = '-';
        const shotCategories = [];

        if(currentCamera === undefined) return;

        const foundRoomCamera = room.cameras.find(c => c.id === currentCamera.id);

        if (!IsNullOrUndefined(foundRoomCamera) && !IsNullOrEmpty(foundRoomCamera.categories))
        {
            foundRoomCamera.categories.forEach(cameraCategory => {
                const foundCategory = categories.find(c => c.id === cameraCategory.id);
                if (!IsNullOrUndefined(foundCategory)){
                    shotCategories.push(foundCategory);
                }
            });
        }

        shotCategories.sort(
            function (a, b) {
                if (a.selected_feature < b.selected_feature) {
                    return -1;
                }
                if (a.selected_feature > b.selected_feature) {
                    return 1;
                }

                return 0;
            });

        for (let countSelection = 0; countSelection < shotCategories.length; countSelection++) {
            categoriesSelectionString += shotCategories[countSelection].selected_feature;

            if (countSelection < shotCategories.length - 1) {
                categoriesSelectionString += categorySelectionSeparator;
            }
        }

        return projectId + sectionSeparator + currentCamera.id + sectionSeparator + categoriesSelectionString;
    },

    updateCameraShots: (projectId, currentRoom, currentCamera, categories) =>
    {
        const currentRoomCameras = currentRoom.cameras;
        let currentRoomShots = [];

        currentRoomCameras.forEach((camera, index) => {
            let shot = CameraShotUtility.getCameraShot(projectId, currentRoom, camera, categories);
            currentRoomShots.push(shot);
        });

        return currentRoomShots;
    },

    findBestCameraForCategory: (focusedCategory, currentRoom, currentCamera, usePriority) => {

        if(focusedCategory !== null && currentCamera !== undefined) {
            let currentRoomCamerasRenderingCategory = [];
            let foundCamera = null;

            currentRoom.cameras.forEach(camera => {
                const cameraWithCategory = camera.categories.filter(c => c.id === focusedCategory.id)[0] || null;
                if (cameraWithCategory !== null) {
                    currentRoomCamerasRenderingCategory.push(camera);
                }
            });

            const currentCameraRenderingCategory = currentRoomCamerasRenderingCategory.filter(c => c.id === currentCamera.id)[0] || null;

            if (currentCameraRenderingCategory !== null)
            {
                return currentCamera;
            } else {
                return currentRoomCamerasRenderingCategory.length > 0 ? currentRoomCamerasRenderingCategory[0] : currentCamera;
            }
        }

        return currentRoom.cameras[0];
    },
    IsIconOnly: (rooms, category, feature) => {
        let isIconOnly = true;
        rooms.forEach(room => {
            room.cameras.forEach(roomCamera => {
                const foundCategory = roomCamera.categories.find(c => c.id === category.id);
                if (!IsNullOrUndefined(foundCategory)) {
                    const foundFeature = foundCategory.features.find(f => f.id === feature.id);
                    if (!IsNullOrUndefined(foundFeature)) {
                        isIconOnly = false;
                    }
                }
            });
        });

        return isIconOnly;
    }
};
